export default __webpack_public_path__ + "e058a0ea6bc4d63c459a034a39ede93f.png";